import { Component, OnInit } from '@angular/core';
import {RacerService} from '../shared/services/databaseServices/racer/racer.service';
import {Racer} from './Racer';
import {faPlus} from '@fortawesome/free-solid-svg-icons';
import {EditService} from '../shared/services/editService/edit.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-racer-tab',
  templateUrl: './racer-tab.component.html',
  styleUrls: ['./racer-tab.component.css']
})
export class RacerTabComponent implements OnInit {

  racers = undefined;
  faPlus = faPlus;

  displayedColumns: string[] = ['name', 'surname', 'year', 'club'];

  header = [
    {
      defName: 'name',
      translation: 'adminPage.racerTab.name',
      elem: 'name'
    },
    {
      defName: 'surname',
      translation: 'adminPage.racerTab.surname',
      elem: 'surname'
    },
    {
      defName: 'year',
      translation: 'adminPage.racerTab.year',
      elem: 'year'
    },
    {
      defName: 'club',
      translation: 'adminPage.racerTab.club',
      elem: 'club'
    }
  ];

  constructor(private racerService: RacerService,
              private editService: EditService,
              private router: Router) {

  }

  ngOnInit() {
    this.racerService.getRacers().then((data) => {
      let racers = [];
      data.forEach(item => {
        const racer: Racer = new Racer();
        racer.key = item.id;
        racer.name = item.data().name;
        racer.surname = item.data().surname;
        racer.club = item.data().club;
        racer.year = item.data().year;

        racers.push(racer);
      });
      this.racers = racers;
    });
  }

  edit(item) {
    this.router.navigate(['/admin/racers', item.key]);
  }

  create() {

  }

  isEdit() {
    return this.editService.editable;
  }



}
